import { ResetPasswordForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

export function ResetPasswordPage() {
  return (
    <AuthLayout>
      <ResetPasswordForm />
    </AuthLayout>
  );
}
